import axios from 'axios';

export function submitForm(params) {
  return axios.post(`/api/internal/form`, params);
}
